import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from "../../../../environments/environment";

const _key = CryptoJS.enc.Utf8.parse(environment.HASH_KEY.trim());
const _iv = CryptoJS.enc.Utf8.parse(environment.HASH_IV);
const _enctryted = environment.dataEncrypted;

@Injectable({
  providedIn: 'root'
})
export class EncryptService {

  constructor() { }

  encrypt(txt: string): string {
    if (_enctryted){
      let encrypted = CryptoJS.AES.encrypt(txt, _key, {
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        format: CryptoJS.format.OpenSSL
      });
      return encrypted.toString();
    } else {
        return txt;
    }
  }

  decrypt(txtToDecrypt: string) {
    if (_enctryted) {
      const dataDecoded = CryptoJS.enc.Base64.parse(txtToDecrypt);
      const ciphertext = CryptoJS.lib.CipherParams.create({
        ciphertext: dataDecoded,
        formatter: CryptoJS.format.OpenSSL
      });
      let dataDecrypted = CryptoJS.AES.decrypt(ciphertext, _key, {
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      const dataUtf8 = dataDecrypted.toString(CryptoJS.enc.Utf8);

      return dataUtf8;
    } else {
      return txtToDecrypt;
    }
  }
}
